
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    getHealthMetricsTopline: ({state, getters, commit, dispatch}, {period, force}) => {

        if (force) state.healthMetricsExpires = null;

        // Pull from store if loaded and cache hasn't expired
        if (state.healthMetricsExpires && moment().isBefore(state.healthMetricsExpires)) {
            return state.healthMetrics;
        }

        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            let url = '/health-metrics/topline';
            let params = [];

            if (force) {
                params.push('force=1');
            }

            params.push('period='+period);

            url = url + '?' + params.join('&');

            axios.get(url)

                .then(({data}) => {

                    commit('setData', data.topline);
                    commit('setActivityByWeekData', data.activityByWeek);
                    commit('setCreatedAt', data.created_at);
                    commit('setLoading', false);
                    resolve(data.topline);
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error);
                });
        });
    },
};
